import { API } from "../../backend";

//category calls
export const createCategory = (userId , token , category) => {
  return fetch(`${API}category/create/${userId}` , {
      method : "POST",
      headers : {
          accept : "application/JSON",
          "Content-Type"  :" application/JSON",
          Authorization: `Bearer ${token}`
      },
      body : JSON.stringify(category)
  })
  .then((response) => {
      return response.json()
  })
  .catch(err => console.log(err));
}

//get all categories
export const getCategories = () => {
    return fetch(`${API}categories`, {
        method : "GET"
    })
    .then(response => {
        return response.json()
    })
    .catch(err => console.log(err))
}

// delete category
export const deleteCategory = (categoryId, userId , token) => {
    return fetch(`${API}category/${categoryId}/${userId}` , {
        method : "DELETE",
        headers :{
           accept : "application/JSON",
           Authorization: `Bearer ${token}` 
        }
    })
    .then(respone => {
        return respone.json()
    })
    .catch(err => console.log(err))
}

//product calls
//create a product
export const createaProduct = (userId , token , product) => {
    return fetch(`${API}product/create/${userId}` , {
        method : "POST",
        headers :{
           accept : "application/JSON",
           Authorization: `Bearer ${token}` 
        },
        body :product
    })
    .then(respone => {
        return respone.json()
    })
    .catch(err => console.log(err))
}

//get all products
export const getProducts = () => {
    return fetch(`${API}products`, {
        method : "GET"
    })
    .then(response => {
        return response.json()
    })
    .catch(err => console.log(err))
}

//delete a product
export const deleteProduct = (productId, userId , token) => {
    return fetch(`${API}product/${productId}/${userId}` , {
        method : "DELETE",
        headers :{
           accept : "application/JSON",
           Authorization: `Bearer ${token}` 
        }
    })
    .then(respone => {
        return respone.json()
    })
    .catch(err => console.log(err))
}

//get a product
export const getProduct = productId => {
    return fetch(`${API}product/${productId}` , {
        method : "GET"
    })
    .then(response => {
        return response.json()
    })
    .catch(err => console.log(err))
}

//update a product
export const updateProduct = (productId, userId, token, product) => {
    return fetch(`${API}product/${productId}/${userId}` , {
        method : "PUT",
        headers :{
           accept : "application/JSON",
           Authorization: `Bearer ${token}` 
        },
        body :product
    })
    .then(respone => {
        return respone.json()
    })
    .catch(err => console.log(err))
}

